module.exports = __webpack_public_path__ + "static/4-87694db20de009fc0739d8e91d0b1455.jpeg";